import { message } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteAllImportedElements } from "../../../data/slices/importedElements";
import Button from "../../Button";
import HeaderOverlay from "../../Project/Header";
import Overlay from "../../Overlay";
import Title from "../../Project/Title";
import Trash from "../../../assets/img/Garbage.svg";

import "./index.scss";

function DeleteImportedCategoryModal({ open, onCancel, data, ...rest }) {
  const [isDeleting, setIsDeleting] = useState(false);

  const dispatch = useDispatch();

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      await dispatch(
        deleteAllImportedElements({
          projectId: data?.projectId,
          values: data?.values,
        })
      ).unwrap();

      message.success(
        "Catégorie et écritures importées supprimées avec succès"
      );

      if (typeof onCancel === "function") {
        onCancel();
      }
      if (data?.onSuccess) {
        data.onSuccess();
      }
    } catch (error) {
      const errorMessage =
        error?.message ||
        error ||
        "Erreur lors de la suppression de la catégorie";
      message.error(errorMessage);
      console.error("Delete error:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  return (
    <Overlay show={open} closable={true}>
      <HeaderOverlay showlogo>
        <Title
          isDelete
          subTitle="Vider la catégorie et supprimer les écritures importées"
          projectTitle={
            <div style={{ width: "80%", margin: "auto" }}>
              Vous allez supprimer toutes les écritures importées qui n'ont pas
              été classées. Êtes-vous sûr de vouloir continuer ? Opération
              irréversible !
            </div>
          }
        />

        <div className="verify-inputs-popup">
          <Button
            text="Non"
            onClick={handleCancel}
            className="action-button cancel-button"
            type="button"
            disabled={isDeleting}
          />
          <Button
            text={"Oui"}
            onClick={handleDelete}
            className={"action-button agree-action-button"}
            icon={"empty"}
            RigthIcon={Trash}
            isRigthIcon
            iconClassName={"delete-icon"}
            loading={isDeleting}
            disabled={isDeleting}
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default DeleteImportedCategoryModal;
